import * as React from "react";
import {
  List,
  TextField,
  SearchInput,
  EditButton,
  BooleanField,
  BooleanInput,
  ReferenceField,
  SelectArrayInput,
  ReferenceArrayInput,
  DataTable,
  DateField,
  Pagination,
} from "react-admin";
import { getCountries } from "../enums/Countries";

const RestaurantDraftFilter = () => [
  <SearchInput source="name" alwaysOn />,
  <SelectArrayInput label="Países" source="country" choices={getCountries()} />,
  <ReferenceArrayInput
    source="region"
    reference="regions"
    perPage={100}
    sort={{ field: "name", order: "ASC" }}
    label="Regiones"
  >
    <SelectArrayInput optionText="name" label="Regiones" />
  </ReferenceArrayInput>,
  <ReferenceArrayInput
    source="districts"
    reference="districts"
    perPage={1000}
    sort={{ field: "name", order: "ASC" }}
    label="Barrios"
  >
    <SelectArrayInput optionText="name" label="Barrios" />
  </ReferenceArrayInput>,
  <BooleanInput label="Con productos" source="withProducts" />,
  <BooleanInput label="Completado" source="onboardingCompleted" />,
  <BooleanInput label="Activo" source="active" />,
];

const RestaurantDraftList = () => {
  return (
    <List
      title={"Solicitudes"}
      filters={RestaurantDraftFilter()}
      exporter={false}
      pagination={true}
      sort={{ field: "createdAt", order: "DESC" }}
    >
      <DataTable bulkActionButtons={false} rowClick="show">
        <DataTable.Col source="name" label="Nombre" />
        <DataTable.Col source="address" label="Dirección" />
        <DataTable.Col source="region" label="Región">
          <ReferenceField
            source="region"
            reference="regions"
            label="Región"
            link={false}
          >
            <TextField source="name" />
          </ReferenceField>
        </DataTable.Col>
        <DataTable.Col source="district" label="Barrio">
          <ReferenceField
            source="district"
            reference="districts"
            link={false}
            label="Barrio"
          >
            <TextField source="name" />
          </ReferenceField>
        </DataTable.Col>
        <DataTable.Col source="createdAt" label="Fecha Registro">
          <DateField
            source="createdAt"
            label="Fecha Registro"
            showTime={true}
            emptyText="-"
          />
        </DataTable.Col>
        <DataTable.Col source="onboardingCompleted" label="Completado">
          <BooleanField
            source="onboardingCompleted"
            label="Completado"
            looseValue
          />
        </DataTable.Col>
        <DataTable.Col source="active" label="Activo">
          <BooleanField source="active" label="Activo" />
        </DataTable.Col>
        <DataTable.Col>
          <EditButton />
        </DataTable.Col>
      </DataTable>
      <Pagination />
    </List>
  );
};
export default RestaurantDraftList;
